import { ServiceOptions } from 'types'
import { SERVICE_MAP_EXAMPLE } from './example'
import { SERVICE_MAP_PAYMENT } from './payment'
import { ServiceParam } from './ServiceParam'

export const SERVICE_MAP: Record<
  keyof ServiceParam,
  ServiceOptions
> = { ...SERVICE_MAP_EXAMPLE, ...SERVICE_MAP_PAYMENT }
